import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnalyticsService } from '../../../api/services/analytics.service';
import { AuthService } from '../../../services/auth.service';
import { QuestionnaireResponseAnswerModel } from '../../../api/models/questionnaire-response-answer-model';
import { ToastService } from '../../../services/toast.service';
import { QuestionnaireInstanceStatus, QuestionType } from '../../../api/models';
import { QuestionnaireAnswersDialogData } from '../../../types/questionnaire-answers-dialog-data';
import { QuestionnaireInstanceService } from '../../../api/services/questionnaire-instance.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-questionnaire-response-answers',
  templateUrl: './questionnaire-response-answers.component.html',
  standalone: false,
})
export class QuestionnaireResponseAnswersComponent implements OnInit {
  answers: QuestionnaireResponseAnswerModel[] | undefined = undefined;
  protected readonly QuestionType = QuestionType;
  protected readonly QuestionnaireInstanceStatus = QuestionnaireInstanceStatus;

  constructor(
    public dialogRef: MatDialogRef<QuestionnaireResponseAnswersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QuestionnaireAnswersDialogData,
    private analyticsService: AnalyticsService,
    private authService: AuthService,
    private toastService: ToastService,
    private questionnaireInstanceService: QuestionnaireInstanceService,
    private router: Router,
  ) {}

  ngOnInit() {
    // Get answers for the specified questionnaire instance
    this.analyticsService
      .analyticsResponseAnswersGetJson(
        {
          questionnaireInstanceGuid: this.data.questionnaireInstanceGuid,
        },
        this.authService.getAuthorisationHeaders(),
      )
      .subscribe({
        next: (answers) => (this.answers = answers),
        error: () => this.toastService.error('Could Not Retrieve Answers'),
      });
  }

  updateQuestionnaireInstance() {
    this.questionnaireInstanceService
      .updatePatch$Response(
        {
          questionnaireInstanceGuid: this.data.questionnaireInstanceGuid,
          isTest: this.data.isTest,
        },
        this.authService.getAuthorisationHeaders(),
      )
      .subscribe();
  }

  navigateToSurveyRespondentDetailsView() {
    if (this.data.surveyRespondentGuid) {
      void this.router.navigate([
        'admin',
        'respondents',
        this.data.surveyRespondentGuid,
      ]);
      this.dialogRef.close();
    }
  }

  navigateToParentQuestionnaireResponse() {
    if (
      this.data.parentQuestionnaireGuid &&
      this.data.parentQuestionnaireInstanceGuid
    ) {
      void this.router.navigate(
        [
          'admin',
          'questionnaire',
          this.data.parentQuestionnaireGuid,
          'analytics',
          'responses',
        ],
        {
          queryParams: {
            questionnaireInstanceGuid:
              this.data.parentQuestionnaireInstanceGuid,
          },
        },
      );
      this.dialogRef.close();
    }
  }

  hasParentQuestionnaireResponse(): boolean {
    return !!(
      this.data.parentQuestionnaireGuid &&
      this.data.parentQuestionnaireInstanceGuid
    );
  }

  hasInvitationMetadata(): boolean {
    return !!(
      this.data.invitedByUserName ||
      this.data.invitedByUserEmail ||
      this.data.invitedByUserGuid ||
      this.data.invitedAt
    );
  }

  getInvitedByLabel(): string {
    return (
      this.data.invitedByUserName ||
      this.data.invitedByUserEmail ||
      this.data.invitedByUserGuid ||
      '-'
    );
  }

  copyQuestionnaireInstanceGuid(event: MouseEvent) {
    event.stopPropagation();
    void navigator.clipboard.writeText(this.data.questionnaireInstanceGuid);
    this.toastService.info('Questionnaire instance GUID copied');
  }
}
